<template>
  <div class="widget">
    <div class="widget-heading">
      <h2 class="textStyle">{{ $t("registration.steps") }}</h2>
    </div>
    <div class="widget-content">
      <ul class="follow">
        <template v-for="step in steps" :key="step.id">
          <li
            class="follow__step"
            :class="{
              isActive:
                step.nextRegistrationTabValidation && Object.keys(step.nextRegistrationTabValidation).length > 0,
              isValid:
                step.registrationStepValidation?.status === registrationConstante.REGISTRATION_STEP_STATUS_VALIDATED,
              isProgress:
                step.registrationStepValidation?.status === registrationConstante.REGISTRATION_STEP_STATUS_PENDING,
              isError:
                step.registrationStepValidation?.status === registrationConstante.REGISTRATION_STEP_STATUS_REFUSED ||
                step.registrationStepValidation?.status === registrationConstante.REGISTRATION_STEP_STATUS_CANCELLED,
            }"
          >
            <div class="follow__icon">
              <FontAwesomeIcon :icon="'fa-light fa-' + step.registrationStep.icon" />
            </div>
            <div class="w-100">
              <div class="follow__label">
                <div class="follow__name">
                  <router-link
                    v-if="step.nextRegistrationTabValidation"
                    :to="{
                      name: 'TrainingPreRegistration',
                      params: {
                        tab: step.nextRegistrationTabValidation.tabConstant,
                        registration: $route.params.registration,
                        group: $route.params.group,
                      },
                    }"
                  >
                    {{ step.registrationStep.name }}</router-link
                  >
                  <span v-else>{{ step.registrationStep.name }}</span>
                </div>
                <div class="d-flex justify-content-end">
                  <div class="follow__status">
                    <FontAwesomeIcon :icon="'fa-light fa-' + statusIcon(step)" />
                  </div>
                </div>
              </div>
              <div
                v-if="
                  step.registrationStepValidation &&
                  step.registrationStepValidation.validationDate &&
                  step.registrationStepValidation.validatorUserFullName
                "
                class="follow__validatedBy"
              >
                {{
                  $tc("registration.validatedAt", {
                    date: step.registrationStepValidation.validationDate
                      ? dateFormatter().format(step.registrationStepValidation.validationDate, "long")
                      : "",
                    validator: step.registrationStepValidation.validatorUserFullName,
                  })
                }}
              </div>
              <div
                v-if="
                  step.registrationStepValidation?.status === registrationConstante.REGISTRATION_STEP_STATUS_PENDING
                "
                class="follow__validatedBy"
              >
                {{ $t("registration.inProgress") }}
              </div>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import { dateFormatter } from "@/services/utilities/date-formatter";
import { registrationConstante } from "@/constantes/registration";

export default {
  name: "RegistrationStepsComponent",
  components: {},
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    registrationConstante() {
      return registrationConstante;
    },
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    dateFormatter() {
      return dateFormatter;
    },

    statusIcon(step) {
      if (step.registrationStepValidation?.status === registrationConstante.REGISTRATION_STEP_STATUS_PENDING) {
        return "hourglass";
      } else if (step.registrationStepValidation?.status === registrationConstante.REGISTRATION_STEP_STATUS_VALIDATED) {
        return "check";
      } else {
        return "xmark";
      }
    },
    init() {},
  },
};
</script>

<style lang="scss" scoped>
.follow {
  list-style: none;
  padding-left: 0;

  &__step {
    display: flex;
    align-items: flex-start;
    --step-color: var(--registration-waiting);
    position: relative;

    &.isActive {
      --step-color: var(--primary-color);

      .follow__name {
        color: var(--step-color);
      }
    }

    &.isValid {
      --step-color: var(--registration-success);

      .follow__label {
        margin-top: 0;
      }
    }

    &.isProgress {
      --step-color: var(--registration-progress);

      .follow__label {
        margin-top: 0;
      }

      .follow__name {
        color: var(--step-color);
      }
    }

    &.isError {
      --step-color: #da5164;

      .follow__label {
        margin-top: 0;
      }
    }

    &:before {
      height: 100%;
      width: 3px;
      background: var(--step-color);
      position: absolute;
      content: "";
      left: 15.5px;
      top: 25px;
      z-index: 0;
    }

    &:last-child {
      &:before {
        display: none;
      }
    }
  }

  &__step + &__step {
    margin-top: 25px;
  }

  &__icon {
    background: var(--step-color);
    display: flex;
    border-radius: 50%;
    border: 3px solid $white;
    align-items: center;
    box-shadow: rgba(0, 0, 0, 0.35) 0 5px 15px;
    justify-content: center;
    min-width: 35px;
    width: 35px;
    min-height: 35px;
    height: 35px;
    margin-right: 10px;
    position: relative;
    z-index: 1;

    svg {
      color: $white;
    }
  }

  &__label {
    font-size: 14px;
    font-weight: 600;
    display: grid;
    grid-template-columns: 3fr 1fr;
    margin-top: 8px;
    align-items: center;
    justify-content: space-between;

    svg {
      color: var(--step-color);
      font-size: 16px;
    }
  }

  &__name {
    color: var(--step-color);
    width: 100%;
    -ms-text-overflow: ellipsis;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &__validatedBy {
    font-size: 12px;
    color: var(--registration-waiting);
  }

  &__status {
    min-width: 18px;
    max-width: 18px;
    min-height: 18px;
    max-height: 18px;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--step-color);
    border-radius: 50%;
    display: flex;

    svg {
      width: 10px;
      height: 10px;
    }
  }
}
.router-link-active:not(.btn) {
  color: var(--registration-waiting) !important;
}
</style>
